<template>
    <div>
        <Card>
            <p slot="title"> Tambah Pembayaran dari Deposit / Potongan </p>

            <Form :label-width="120">
                <Form-item label="Kode Penyesuaian">
                    <Select
                        v-model="categoryId"
                        placeholder="Select"
                        clearable
                        filterable
                        style="width: 360px;"
                        @on-change="categoryId == null ? paymentDate = '' : true">
                        <Option
                            v-for="category in categories"
                            :value="category.id"
                            :key="category.id">{{ category.category }}</Option>
                    </Select>
                </Form-item>
                <Form-item label="Tgl Pembayaran">
                    <Row>
                        <Col span="4">
                        <Date-picker v-model="paymentDate" style="width: 110px;" type="date" placeholder="" :options="dateOptions"
                            format="dd/MM/yyyy" :disabled="categoryId == null" :style="{ 'pointer-events: none': categoryId == null }">
                        </Date-picker>
                        </Col>
                        <Col span="2">
                        <Select v-if="searchSelectSubbranch == 'JKT'" v-model="searchSelectSubbranch" disabled
                            placeholder="Branchcode" @on-change="setMarkingCode">
                            <Option v-for="subbranch, idx in subbranchs" :value="subbranch.subbranchcode" :key="idx">
                                {{ subbranch.subbranchname }}
                            </Option>
                        </Select>
                        <Select v-else v-model="searchSelectSubbranch" disabled placeholder="Branchcode"
                            @on-change="setMarkingCode">
                            <Option v-for="subbranch, idx in subbranchs" :value="subbranch.subbranchcode" :key="idx">
                                {{ subbranch.subbranchname }}
                            </Option>
                        </Select>
                        </Col>
                        <Col span="1">&nbsp;</Col>
                        <Col span="3">
                        <i-switch size="large" v-model="isGroup" @on-change="handleSwitchChange">
                            <span slot="open">Group</span>
                            <span slot="close">Mark</span>
                        </i-switch>
                        </Col>
                        <Col span="5" v-show="paymentDate != '' && isGroup == false">
                        <Select style="width: 250px;" placeholder="Ketik Marking" v-model="markingIdSelected" filterable
                            clearable remote :remote-method="getMarkingByCode" :loading="loadingGetMarking"
                            @on-change="getInvoiceData">
                            <Option v-for="option in optionMarkings" :value="option.value" :key="option.value">
                                {{ option.label }}</Option>
                        </Select>
                        </Col>
                        <Col span="5" v-show="paymentDate != '' && isGroup == true">
                        <Select style="width: 250px;" placeholder="Ketik Group Name" v-model="markingIdSelected"
                            filterable clearable remote :remote-method="getGroupMarkingByCode"
                            :loading="loadingGetMarking" @on-change="getInvoiceDataByGroupMarking">
                            <Option v-for="option in optionGroupMarkings" :value="option.value" :key="option.value">
                                {{ option.label }}</Option>
                        </Select>
                        </Col>
                        <Col span="1" offset="1">
                        <Spin size="large" v-show="loadingGetPayment"></Spin>
                        </Col>
                    </Row>
                </Form-item>

                <Form-item label="Keterangan"
                    v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0">
                    <Input v-model="description" style="width: 300px;"></Input>
                </Form-item>

                <Form-item label="Total Deposit"
                    v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && depositRemaining != 0">
                    <Alert style="width: 300px;" type="warning" show-icon>
                        {{ depositRemaining | currency }}
                    </Alert>
                    <font style="color: red;"
                        v-if="totalUseDepositAmount > 0 && totalUseDepositAmount > depositRemaining">Terpakai
                        {{ totalUseDepositAmount | currency }} - LEBIH
                    </font>

                    <font style="color: green;"
                        v-if="totalUseDepositAmount > 0 && totalUseDepositAmount <= depositRemaining">
                        Terpakai: {{ totalUseDepositAmount | currency }}, Sisa: {{ (depositRemaining -
                            totalUseDepositAmount) | currency }}
                    </font>
                </Form-item>

                <Form-item label="Total Mutasi Deposit"
                    v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && depositMutasiRemaining">
                    <Alert style="width: 300px;" type="warning" show-icon>
                        {{ depositMutasiRemaining | currency }}
                    </Alert>

                    <font style="color: red;"
                        v-if="totalUseDepositMutasi > 0 && totalUseDepositMutasi > depositMutasiRemaining">Terpakai
                        {{ totalUseDepositMutasi | currency }} - LEBIH
                    </font>

                    <font style="color: green;"
                        v-if="totalUseDepositMutasi > 0 && totalUseDepositMutasi <= depositMutasiRemaining">
                        Terpakai: {{ totalUseDepositMutasi | currency }}, Sisa: {{ (depositMutasiRemaining -
                            totalUseDepositMutasi) |
                            currency }}
                    </font>
                </Form-item>

                <Form-item :label="'Deposit ' + selectGroup"
                    v-show="paymentDate != '' && markingIdSelected != '' && groupDepositRemaining != 0 && isGroup">
                    <Alert style="width: 300px;" type="warning" show-icon> {{ groupDepositRemaining | currency }}
                    </Alert>
                    <!-- <font
                      style="color: red;"
                      v-if="totalUseDepositAmount > 0 && totalUseDepositAmount > depositRemaining">Terpakai {{totalUseDepositAmount | currency}} - LEBIH
                  </font>

                  <font
                      style="color: green;"
                      v-if="totalUseDepositAmount > 0 && totalUseDepositAmount <= depositRemaining">
                          Terpakai: {{totalUseDepositAmount | currency}}, Sisa: {{ (depositRemaining - totalUseDepositAmount) | currency}}
                  </font> -->
                </Form-item>

                <Form-item label="Uang Diterima"
                    v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0">
                    <money v-model="amountReceived" v-bind="money" class="ivu-input right" style="width: 150px;">
                    </money>

                    <font v-show="amountResidue != 0" style="margin-left: 20px;">
                        Selisih &nbsp; {{ amountResidue | currency }}
                    </font>
                </Form-item>

                <Form-item label="Pembulatan"
                    v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0">
                    <money v-model="creditRound" v-bind="money" class="ivu-input right" style="width: 150px;"></money>
                </Form-item>
                <Form-item label="Chart of Account"
                    v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && creditRound > 0">
                    <Select v-model="coaId" clearable filterable style="width: 300px;">
                        <Option v-for="coa in COAs" :value="coa.id" :key="coa.id">{{ coa.account_name }}</Option>
                    </Select>
                </Form-item>

                <Form-item label="Uang Potongan"
                    v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && paymentPendingId">
                    <money v-model="discountReceived" v-bind="money" class="ivu-input right" style="width: 150px;">
                    </money>
                </Form-item>
                <Form-item label="Kategori"
                    v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && paymentPendingId == null">
                    <input type="radio" v-model="category" id="payment" value="pay"> <label
                        for="payment">Pembayaran</label> &nbsp;&nbsp;&nbsp;
                    <input type="radio"
                        v-show="usernameAccess == 'susan' || usernameAccess == 'LINDA' || usernameAccess == 'fcl-sby' || usernameAccess == 'FONGFONG' || usernameAccess == 'MERRY' || usernameAccess == 'VIKA' || usernameAccess == 'ERIC' || usernameAccess == 'EVA-BKK' || usernameAccess == 'ADMIN-BKK' || usernameAccess == 'KENZA-BALI' || usernameAccess == 'ADRI' || usernameAccess == 'SYSTEM' "
                        v-model="category" id="discount" value="disc"> <label
                        v-show="usernameAccess == 'susan' || usernameAccess == 'LINDA' || usernameAccess == 'fcl-sby' || usernameAccess == 'FONGFONG' || usernameAccess == 'MERRY' || usernameAccess == 'VIKA' || usernameAccess == 'ERIC' || usernameAccess == 'EVA-BKK' || usernameAccess == 'ADMIN-BKK' || usernameAccess == 'KENZA-BALI' || usernameAccess == 'ADRI' || usernameAccess == 'SYSTEM' "
                        for="discount">Potongan</label>
                </Form-item>
                <Form-item label="Kategori"
                    v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && paymentPendingId">
                    <input type="radio" v-model="category" id="payment" value="pay"> <label
                        for="payment">Pembayaran</label> &nbsp;&nbsp;&nbsp;
                </Form-item>

                <Alert v-show="depositAmount != 0" type="warning" show-icon style="width: 300px;">Kelebihan :
                    {{ depositAmount | currency }}</Alert>

                <Alert v-show="depositAmount != 0 && category == 'disc'" type="error" show-icon style="width: 700px;">
                    Tidak dapat melanjutkan proses pembayaran jika terdapat Kelebihan pada Kategori Potongan.</Alert>
                <Alert v-show="depositAmount > paymentPendingAmount && paymentPendingId" type="error" show-icon
                    style="width: 700px;"> Tidak dapat melanjutkan proses pembayaran jika Alokasi Pembayaran lebih besar
                    dari Mutasi.</Alert>

                <Button v-show="paymentDate != '' && markingIdSelected != '' && groupDepositRemaining != 0 && isGroup">
                    Total Alokasi Marking {{ selectGroup }} : {{ totalAmountSelect | currency }}
                </Button>
            </Form>
        </Card>

        <br />

        <Card v-show="this.invoiceDues.length > 0 && receivableGroup == ''">
            <p slot="title"> Daftar Invoices </p>

            <Row type="flex" class="code-row-bg ivu-row-flex-space-between">
                <template>
                    <Col span="2"> Tgl Bongkar </Col>
                    <Col span="6"> Keterangan </Col>
                    <Col span="3"> Total </Col>
                    <Col span="3"> Sisa </Col>
                    <Col span="3"> Alokasi Pembayaran </Col>
                    <Col span="5"> Potongan </Col>
                </template>
            </Row>

            <br />
            <hr /> <br />

            <div>
                <div v-if="paymentMarking.includes('SBR/') || paymentMarking.includes('SBRT/')">
                    <div v-for="invoiceDue in invoiceDues" :key="invoiceDue.id">
                        <cInvoicePaymentDecimal :invoiceDue="invoiceDue" :depositRemaining="depositRemaining"
                            :depositMutasiRemaining="depositMutasiRemaining"
                            :paymentPendingId="paymentPendingId" :paymentPendingAmount="paymentPendingAmount"
                            @setAllocateAmount="setAllocateAmount"></cInvoicePaymentDecimal>
                        <br />
                    </div>
                </div>
                <div v-else>
                    <div v-for="invoiceDue in invoiceDues" :key="invoiceDue.id">
                        <cInvoicePayment :invoiceDue="invoiceDue" :depositRemaining="depositRemaining"
                            :depositMutasiRemaining="depositMutasiRemaining" :paymentPendingId="paymentPendingId"
                            :paymentPendingAmount="paymentPendingAmount" @setAllocateAmount="setAllocateAmount">
                        </cInvoicePayment>
                        <br />
                    </div>
                </div>
            </div>
        </Card>

        <Card v-if="receivableGroup != ''">
            <Tabs :animated="false" @on-click="groupClickHandle">
                <TabPane v-for="marking in receivableGroup" :key="marking.markingheadercode"
                    :label="marking.markingheadercode">
                    <p slot="title"> Daftar Invoice </p>
                    <Row type="flex" class="code-row-bg">
                        <template>
                            <Col span="2"> Tgl Bongkar</Col>
                            <Col span="6"> Keterangan </Col>
                            <Col span="3"> Total </Col>
                            <Col span="3"> Sisa </Col>
                            <Col span="3"> Alokasi Pembayaran </Col>
                            <Col span="5"> Potongan </Col>
                        </template>
                    </Row>
                    <br />
                    <hr /> <br />
                    <div v-for="invoiceDue in marking.invoiceDue" :key="invoiceDue.id">
                        <cInvoicePayment :invoiceDue="invoiceDue" :depositRemaining="depositRemaining"
                            :depositMutasiRemaining="depositMutasiRemaining" :paymentPendingId="paymentPendingId"
                            :paymentPendingAmount="paymentPendingAmount" @setAllocateAmount="setAllocateAmount">
                        </cInvoicePayment>
                        <br />
                    </div>
                </TabPane>
            </Tabs>
        </Card>

        <div class="footer" v-show="isGroup == false">
            <Button
                v-show="description != '' && category != '' && (((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) || ((totalUseDepositMutasi <= depositMutasiRemaining) || depositMutasiRemaining < 0)) && paymentPendingId == null && (creditRound == 0 || creditRound > 0 && coaId != null)"
                type="primary" :loading="loadingPost" @click="postPayment" icon="checkmark-round" size="small">
                <span
                    v-if="!loadingPost && (amountReceived + totalUseDepositAmount + totalUseDepositMutasi > 0)">Bayar</span>
                <span v-else-if="!loadingPost && (amountReceived == 0)">Bayar Free</span>
                <span v-else>Wait.....</span>
            </Button>
        </div>
        <div class="footer" v-show="isGroup">
            <Button
                v-show="description != '' && category != '' && (((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) || ((totalUseDepositMutasi <= depositMutasiRemaining) || depositMutasiRemaining < 0)) && (creditRound == 0 || creditRound > 0 && coaId != null)"
                type="primary" :loading="loadingPost" @click="postPaymentByGroup" icon="checkmark-round" size="small">
                <span
                    v-if="!loadingPost && amountReceived + totalUseDepositAmount + totalUseDepositMutasi > 0">Bayar</span>
                <span v-else-if="!loadingPost && (amountReceived == 0)">Bayar Free</span>
                <span v-else>Wait.....</span>
            </Button>
        </div>

        <Modal v-model="modalConfirmDeposit" width="500px" @on-cancel="depositType = ''">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Konfirmasi</span>
            </p>
            Kelebihan <b>{{ depositAmount | currency }}</b> akan dijadikan sebagai :
            <div style="text-align:left">
                <RadioGroup v-model="depositType" vertical>
                    <Radio label="DEP">
                        <span>Deposit</span>
                    </Radio>
                    <Radio label="PRF">
                        <span>Pendapatan</span>
                    </Radio>
                </RadioGroup>
            </div>
            <div slot="footer" v-show="isGroup == false && paymentPendingId == null">
                <Button v-show="depositType != ''" type="primary" long :loading="loadingPost" @click="postPayment">
                    <span v-if="!loadingPost">Bayar</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
            <div slot="footer" v-show="isGroup">
                <Button v-show="depositType != ''" type="primary" long :loading="loadingPost"
                    @click="postPaymentByGroup">
                    <span v-if="!loadingPost">Bayar</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { HTTP } from '../http-lib';
import { Money } from 'v-money'
import _ from 'lodash'
import moment from 'moment'
import cInvoicePayment from '@/components/receivable/cInvoicePayment'
import cInvoicePaymentDecimal from '@/components/payment/cInvoicePaymentDecimal'
import { trim } from 'lodash';

const numeral = require('numeral');
var axios = require('axios');

export default {
    components: { cInvoicePayment, cInvoicePaymentDecimal, Money },
    props: {
        paymentPendingId: Number,
        // paymentDate : Date,
        paymentPendingAmount: String
    },

    data: () => ({
        paymentMarking: '',
        isGroup: false,

        categories: [],
        categoryId: null,

        optionMarkings: [],
        optionGroupMarkings: [],
        receivableGroup: [],
        modalConfirmDeposit: false,
        amountReceived: 0,
        discountReceived: '',
        amountResidue: '',
        depositType: '',
        depositAmount: '', // untuk menampung kelebihan bayar
        depositRemaining: 0, // untuk menampung total sisa deposit
        depositMutasiRemaining: 0,
        groupDepositRemaining: 0, // untuk menampung total sisa deposit grup
        totalUseDepositAmount: 0,
        totalUseDepositMutasi: 0,
        loadingGetPayment: false,
        accountNumber: '',
        paymentDate: '',
        description: '',
        transactionDate: '',
        markingIdSelected: '',
        loadingGetMarking: false,
        invoiceDues: [],
        loadingPost: false,
        paymentAllocates: [],
        postData: [],
        payments: [],
        searchSelectSubbranch: localStorage.getItem('user.subbranchcode'),
        subbranchs: '',
        selectGroup: '',
        totalAmountSelect: 0,
        usernameAccess: '',
        dateOptions: {
          disabledDate(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // normalize
            return date > today; // disable future date
          }
        },
        tableColumns: [
            {
                title: 'Tgl',
                key: 'paymentDate',
                sortable: false
            },
            {
                title: 'Marking',
                key: 'markingHeaderId',
                sortable: false
            },
            {
                title: 'Keterangan',
                key: 'description',
                sortable: false
            },
            {
                title: 'Jumlah',
                key: 'creditAmount',
                sortable: false
            }
        ],
        filterInput: '',
        money: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: 2,
            masked: false
        },
        category: '',
        creditRound: 0,
        coaId: null,
        COAs: [],
        listMarkingGroup: [],
    }),
    methods: {
        isDeviation: function (invoiceDue) {
            if (invoiceDue.allocateAmount + invoiceDue.useDepositAmount > invoiceDue.receivableRemaining) {
                return true;
            }
            return false;
        },
        countTotalAllocateAmount: function (invoiceDue) {
            return (invoiceDue.allocateAmount + invoiceDue.useDepositAmount) - invoiceDue.receivableRemaining;
        },
        setAllocateAmount: function (invoiceDue) {
            if (this.isDeviation(invoiceDue)) {
                invoiceDue.deviationAmount = this.countTotalAllocateAmount(invoiceDue)
            } else {
                invoiceDue.deviationAmount = 0
            }

            var index = _.findIndex(this.invoiceDues, { id: invoiceDue.id });

            // Replace item at index using native splice
            this.invoiceDues.splice(index, 1, invoiceDue);

            // var invoiceDueChanged = _.find(this.invoiceDues, {id: invoiceDue.id});
            this.setResidueAmount(true);

            this.totalAmountSelect = 0

            if (this.isGroup) {
                this.receivableGroup.find(o => o.markingheadercode == this.selectGroup).invoiceDue.forEach(o => {
                    this.totalAmountSelect += o.allocateAmount
                })
            }
        },
        countTotalAllocateMutasiAmount: function (invoiceDue) {
            return (invoiceDue.allocateMutasiAmount + invoiceDue.useDepositMutasiAmount) - invoiceDue.receivableRemaining;
        },
        setAllocateMutasiAmount: function (invoiceDue) {
            if (this.isDeviation(invoiceDue)) {
                invoiceDue.deviationAmount = this.countTotalAllocateMutasiAmount(invoiceDue)
            } else {
                invoiceDue.deviationAmount = 0
            }

            var index = _.findIndex(this.invoiceDues, { id: invoiceDue.id });

            // Replace item at index using native splice
            this.invoiceDues.splice(index, 1, invoiceDue);

            // var invoiceDueChanged = _.find(this.invoiceDues, {id: invoiceDue.id});
            this.setResidueAmount(true);

            this.totalAmountSelect = 0

            if (this.isGroup) {
                this.receivableGroup.find(o => o.markingheadercode == this.selectGroup).invoiceDue.forEach(o => {
                    this.totalAmountSelect += o.allocateAmount
                })
            }
        },
        setResidueAmount: function (fromChild) {
            let allocateAmounts = _.sumBy(this.invoiceDues, 'allocateAmount');
            let allocateDiscountAmounts = _.sumBy(this.invoiceDues, 'discountAmount');
            let allocateDepositMutasi = _.sumBy(this.invoiceDues, 'useDepositMutasi');
            this.amountResidue = this.amountReceived - (allocateAmounts + allocateDepositMutasi);

            console.log("OK : " + this.amountReceived);


            if (fromChild) {
                this.totalUseDepositAmount = _.sumBy(this.invoiceDues, 'useDepositAmount');
                this.totalUseDepositMutasi = _.sumBy(this.invoiceDues, 'useDepositMutasi');
                this.discountReceived = allocateDiscountAmounts;
            }

            let sumDeviation = _.sumBy(this.invoiceDues, 'deviationAmount');
            this.depositAmount = sumDeviation

            this.amountReceived = allocateAmounts + allocateDepositMutasi;
        },
        getDepositRemaining: function () {
            if (this.markingIdSelected !== '') {
                return HTTP.get('deposit/remaining/' + this.markingIdSelected)
            } else {
                this.depositRemaining = 0;
            }
        },
        getDepositMutasiRemaining: function () {
            if (this.markingIdSelected !== '') {
                return HTTP.get('deposit/mutasi/' + this.markingIdSelected)
            } else {
                this.depositMutasiRemaining = 0;
            }
        },
        getInvoiceDueUnSettled: function () {
            if (this.markingIdSelected !== '') {
                return HTTP.get('invoiceDue/unsettled/' + this.markingIdSelected)
            } else {
                this.invoiceDues = []
            }
        },
        getInvoiceDueUnSettledByGroup: function () {
            if (this.markingIdSelected !== '') {
                return HTTP.get('invoiceDue/unsettledByGroup/' + this.markingIdSelected)
            } else {
                this.invoiceDues = []
            }
        },
        getSubbranch: function () {
            HTTP
                .get('subbranch')
                .then(response => {
                    this.subbranchs = response.data
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },

        getInvoiceData: function () {
            this.loadingGetPayment = true;

            this.invoiceDues = []
            this.amountResidue = ''
            this.amountReceived = 0
            this.description = ''
            this.depositRemaining = 0;
            this.depositMutasiRemaining = 0;
            this.totalUseDepositAmount = 0;
            this.totalUseDepositMutasi = 0;

            if (this.markingIdSelected == '' || this.isGroup) {
                this.loadingGetPayment = false;
                return;
            }

            let parent = this;

            axios.all([
                this.getInvoiceDueUnSettled(),
                this.getDepositRemaining(),
                this.getDepositMutasiRemaining()
            ]).then(axios.spread((unSettledRes, depositRemainingRes, depositMutasiRes) => {
                let invoiceDuesFormatted = []
                console.log({unSettledRes});

                _.forEach(unSettledRes.data, function (value) {

                    let receivableType = value.receivable.type;

                    let invoicefee = value.receivable.debitAmount;
                    let invoicedate = value.receivable.transactionDate;
                    let invoicedatedue = '';

                    if (receivableType != 'MAN') {
                        let invoicefee = value.receivable.invoice.invoicefee;
                        let invoicedatedue = value.receivable.invoice.invoicedatedue;
                        let invoicedate = value.receivable.invoice.invoicedate;
                    }

                    let paymentSum = value.paymentSum;
                    let receivableRemaining = invoicefee - paymentSum;
                    let receivableDebitAmount = value.receivable.debitAmount;

                    let payment = {
                        id: value.id,
                        receivableId: value.receivableId,
                        invoicefee: invoicefee, // Jika ada invoice, nilai ini dapat berubah jika repricing
                        paymentSum: paymentSum,
                        receivableRemaining: receivableRemaining,
                        description: value.receivable.description,
                        invoicedate: invoicedate, //numeral(value.receivable.creditAmount).format('0,0')
                        invoicedatedue: invoicedatedue,
                        receivableDebitAmount: receivableDebitAmount, // menyimpan nilai awal
                        allocateAmount: 0,
                        deviationAmount: 0, // untuk menyimpan kelebihan bayar
                        useDepositAmount: 0, // nilai penggunaan deposit (jika ada deposit)
                        useDepositMutasi: 0,
                        markingHeaderId: value.receivable.markingHeaderId,
                        pendingAmount: 0,
                        discountAmount: 0
                    }

                    invoiceDuesFormatted.push(payment);
                });

                if (invoiceDuesFormatted.length > 0) {
                    invoiceDuesFormatted = _.sortBy(invoiceDuesFormatted, ['invoicedate'], function (value) { return new Date(value); });

                    let pendingAmount = this.paymentPendingAmount;
                    let index = 0;

                    if (pendingAmount && pendingAmount > 0) {
                        _.forEach(invoiceDuesFormatted, function (value) {
                            if (pendingAmount && pendingAmount > 0 && pendingAmount > value.receivableRemaining) {
                                invoiceDuesFormatted[index].pendingAmount = value.receivableRemaining;
                                pendingAmount = pendingAmount - value.receivableRemaining;
                            } else if (pendingAmount && pendingAmount > 0 && pendingAmount <= value.receivableRemaining) {
                                invoiceDuesFormatted[index].pendingAmount = pendingAmount;
                                pendingAmount = 0;
                            }

                            index++;
                        });
                    }

                    console.log({invoiceDuesFormatted});
                    parent.invoiceDues = invoiceDuesFormatted;
                    parent.depositRemaining = depositRemainingRes.data.remaining
                    parent.depositMutasiRemaining = depositMutasiRes.data.remaining

                } else {
                    if (this.markingIdSelected) {
                        this.$Message.info('Piutang tidak ditemukan');
                    }
                }

                parent.loadingGetPayment = false;
            }))
                .catch(e => {
                    console.log(e)
                    this.loadingGetPayment = false;
                    this.$Notice.error({
                        title: "Error",
                        desc: 'Silahkan Cek Menu Piutang > Hapus Piutang',
                        duration: 0
                    });
                });
        },

        getInvoiceDataByGroupMarking: function () {
            this.loadingGetPayment = true;

            this.invoiceDues = []
            this.amountResidue = ''
            this.amountReceived = 0
            this.description = ''
            this.groupDepositRemaining = 0;
            this.totalUseDepositAmount = 0;

            if (this.markingIdSelected == '' || this.isGroup == false) {
                this.loadingGetPayment = false;
                return;
            }

            let parent = this;

            axios.all([
                this.getInvoiceDueUnSettledByGroup(),
                this.getDepositRemaining(),
                this.getDepositMutasiRemaining()
            ]).then(axios.spread((unSettledRes, depositRemainingRes, depositMutasiRes) => {
                let invoiceDuesFormatted = []
                this.receivableGroup = []

                _.forEach(unSettledRes.data, function (value) {

                    let receivableType = value.receivable.type;
                    console.log({value});

                    let invoicefee = value.receivable.debitAmount;
                    let invoicedate = value.receivable.transactionDate;
                    let invoicedatedue = '';

                    if (receivableType != 'MAN') {
                        let invoicefee = value.receivable.invoice.invoicefee;
                        let invoicedatedue = value.receivable.invoice.invoicedatedue;
                        let invoicedate = value.receivable.invoice.invoicedate;
                    }

                    let paymentSum = value.paymentSum;
                    let receivableRemaining = invoicefee - paymentSum;
                    let receivableDebitAmount = value.receivable.debitAmount;

                    let payment = {
                        id: value.id,
                        receivableId: value.receivableId,
                        invoicefee: invoicefee, // Jika ada invoice, nilai ini dapat berubah jika repricing
                        paymentSum: paymentSum,
                        receivableRemaining: receivableRemaining,
                        description: value.receivable.description,
                        invoicedate: invoicedate, //numeral(value.receivable.creditAmount).format('0,0')
                        invoicedatedue: invoicedatedue,
                        receivableDebitAmount: receivableDebitAmount, // menyimpan nilai awal
                        allocateAmount: 0,
                        deviationAmount: 0, // untuk menyimpan kelebihan bayar
                        useDepositAmount: 0, // nilai penggunaan deposit (jika ada deposit)
                        useDepositMutasi: 0,
                        markingHeaderId: value.receivable.markingHeaderId,
                        markingHeaderCode: value.receivable.marking_minified.markingheadercode,
                    }

                    invoiceDuesFormatted.push(payment);
                });

                if (invoiceDuesFormatted.length > 0) {
                    invoiceDuesFormatted = _.sortBy(invoiceDuesFormatted, ['invoicedate'], function (value) { return new Date(value); });

                    parent.receivableGroup = groupBy(invoiceDuesFormatted, 'markingHeaderCode', 'markingheadercode', 'invoiceDue')
                    parent.invoiceDues = invoiceDuesFormatted;
                    // parent.groupDepositRemaining = depositRemainingRes.data.remaining

                    parent.depositRemaining = depositRemainingRes.data.remaining
                    parent.depositMutasiRemaining = depositMutasiRes.data.remaining

                } else {
                    if (this.markingIdSelected) {
                        this.$Message.info('Piutang tidak ditemukan');
                        parent.loadingGetPayment = false;
                        return;
                    }
                }

                parent.loadingGetPayment = false;
                parent.groupClickHandle(0)
            }))
                .catch(e => {
                    this.loadingGetPayment = false;
                    console.log(e);

                    this.$Notice.error({
                        title: "Error",
                        desc: 'Silahkan Cek Menu Piutang > Hapus Piutang',
                        duration: 0
                    });
                });
        },

        postPayment: function () {

            if (this.depositAmount > 0 && this.depositType == '') {
                this.modalConfirmDeposit = true;
                return;
            } else {
                this.modalConfirmDeposit = false;
            }

            this.loadingPost = true
            let paymentAllocates = [];
            let paymentDiscountAllocates = [];

            console.log(this.invoiceDues)

            _.forEach(this.invoiceDues, function (invoiceDue) {
                if ((invoiceDue.allocateAmount + invoiceDue.useDepositAmount != 0 || invoiceDue.allocateAmount + invoiceDue.useDepositMutasi != 0) || invoiceDue.invoicefee == 0) {
                    let paymentAllocate = {
                        invoicefee: invoiceDue.invoicefee,
                        invoiceDueId: invoiceDue.id,
                        allocateAmount: invoiceDue.allocateAmount,
                        receivableRemaining: invoiceDue.receivableRemaining,
                        useDepositAmount: invoiceDue.useDepositAmount,
                        useDepositMutasi: invoiceDue.useDepositMutasi,
                        description: invoiceDue.description,
                    }

                    paymentAllocates.push(paymentAllocate);
                }

                if (invoiceDue.discountAmount && invoiceDue.discountDescription) {
                    let paymentAllocate = {
                        invoicefee: invoiceDue.invoicefee,
                        invoiceDueId: invoiceDue.id,
                        allocateAmount: invoiceDue.discountAmount,
                        receivableRemaining: invoiceDue.receivableRemaining,
                        useDepositAmount: 0,
                        useDepositMutasi: 0,
                        description: invoiceDue.discountDescription,
                    }
                    paymentDiscountAllocates.push(paymentAllocate);
                }
            });

            this.paymentAllocates = paymentAllocates;
            let transactionDate = moment(this.paymentDate).format('YYYY/MM/DD')

            let payload = {
                markingHeaderId: this.markingIdSelected,
                amount: this.amountReceived,
                transactionDate: transactionDate,
                description: this.description,
                accountNumber: this.accountNumber,
                depositAmount: this.depositAmount,
                paymentAllocates: this.paymentAllocates,
                depositType: this.depositType,
                type: 'ADJUSTMENT',
                category: this.category,
                categoryId: this.categoryId,
                paymentDiscountAllocates: paymentDiscountAllocates,
                // paymentPendingId: this.paymentPendingId,
                // creditRound: this.creditRound,
                // coaId: this.creditRound > 0 ? this.coaId : null
            }

            // console.log('1: ');
            console.log({payload});
            // return false

            HTTP
                .post('payment/pay', payload)
                .then(response => {
                    console.log({response});

                    this.loadingPost = false

                    console.log('Payment successfully');
                    this.$Message.success({
                        content: 'Pembayaran Berhasil',
                        duration: 5
                    });

                    if (response.data) {
                        // let paymentId = response.data.paymentId
                        // let receivableId = response.data.receivableId

                        // let ntPayload = {
                        //     paymentId: paymentId,
                        //     receivableId: receivableId,
                        //     categoryId: this.categoryId,
                        // }

                        // console.log({ntPayload});

                        console.log('Transaction note automatically created');
                        this.$Message.success({
                            content: 'Nota transaksi otomatis, berhasil dibuat ! ',
                            duration: 5
                        });

                        this.getInvoiceData();

                        // return false

                        // HTTP.post('transaction-note-adjustment/create', ntPayload)
                        // .then(response => {
                        //     console.log({response});

                        //     this.$Message.success({
                        //         content: 'Nota transaksi otomatis, berhasil dibuat ! ',
                        //         duration: 5
                        //     });

                        //     this.getInvoiceData();
                        // })
                        // .catch(err => {
                        //     this.$Notice.error({
                        //         title: "Transaction Note Error",
                        //         desc: err,
                        //         duration: 5
                        //     });
                        // });
                    }
                })
                .catch(err => {
                    this.loadingPost = false
                    this.$Notice.error({
                        title: "Payment Error",
                        desc: err,
                        duration: 5
                    });
                })
        },
        postPaymentByGroup: function () {
            if (this.depositAmount > 0 && this.depositType == '') {
                this.modalConfirmDeposit = true;
                return;
            } else {
                this.modalConfirmDeposit = false;
            }

            var paymentDate = this.paymentDate;
            var description = this.description;
            var accountNumber = this.accountNumber;
            var depositType = this.depositType;
            var category = this.category;
            // var paymentPendingId = this.paymentPendingId;
            var markingIdSelected = this.markingIdSelected;

            var groupByCategory = _.groupBy(this.invoiceDues, invoiceDue => invoiceDue.markingHeaderId);
            this.loadingPost = true

            var isResponse = true;
            // var depositUse = 0;

            _.forEach(groupByCategory, function (invoiceDue) {
                let paymentAllocates = [];
                let amount = 0;
                let deviationAmount = 0;
                var markingheaderid = '';
                var paymentDiscountAllocates = [];

                _.forEach(invoiceDue, function (invoiceDue) {

                    if ((invoiceDue.allocateAmount + invoiceDue.useDepositAmount != 0 || invoiceDue.allocateAmount + invoiceDue.useDepositMutasi != 0) || invoiceDue.invoicefee == 0) {
                        let paymentAllocate = {
                            invoicefee: invoiceDue.invoicefee,
                            invoiceDueId: invoiceDue.id,
                            allocateAmount: invoiceDue.allocateAmount,
                            receivableRemaining: invoiceDue.receivableRemaining,
                            useDepositAmount: invoiceDue.useDepositAmount,
                            useDepositMutasi: invoiceDue.useDepositMutasi,
                            description: invoiceDue.description,
                        }

                        amount = amount + invoiceDue.allocateAmount + invoiceDue.useDepositAmount + invoiceDue.useDepositMutasi;
                        deviationAmount = deviationAmount + invoiceDue.deviationAmount;
                        paymentAllocates.push(paymentAllocate);
                    }

                    markingheaderid = invoiceDue.markingHeaderId;

                    if (invoiceDue.discountAmount && invoiceDue.discountDescription) {
                        let paymentAllocate = {
                            invoicefee: invoiceDue.invoicefee,
                            invoiceDueId: invoiceDue.id,
                            allocateAmount: invoiceDue.discountAmount,
                            receivableRemaining: invoiceDue.receivableRemaining,
                            useDepositAmount: 0,
                            useDepositMutasi: 0,
                            description: invoiceDue.discountDescription,
                        }
                        paymentDiscountAllocates.push(paymentAllocate);
                    }
                });

                if (amount >= 0) {
                    let transactionDate = moment(paymentDate).format('YYYY/MM/DD')
                    let payload = {
                        markingHeaderId: markingheaderid,
                        markingGroupId: markingIdSelected,
                        amount: amount,
                        transactionDate: transactionDate,
                        description: description,
                        accountNumber: accountNumber,
                        depositAmount: deviationAmount, // handle deviation amount as deposit
                        paymentAllocates: paymentAllocates,
                        depositType: depositType,
                        category: category,
                        type: 'ADJUSTMENT',
                        // paymentPendingId: paymentPendingId,
                        paymentDiscountAllocates: paymentDiscountAllocates
                    }

                    HTTP
                        .post('payment/pay', payload)
                        .then(response => {
                            isResponse = true;
                        })
                        .catch(err => {
                            err;
                        })
                }
            });

            if (isResponse) {
                this.loadingPost = false
                this.getInvoiceDataByGroupMarking();

                this.$Message.success({
                    content: 'Pembayaran Berhasil',
                    duration: 5
                });
            } else {
                this.loadingPost = false

                this.$Notice.error({
                    title: "Error",
                    desc: isDescriptionResponse,
                    duration: 5
                });
            }

            this.getInvoiceDataByGroupMarking();
        },

        getCategories: function() {
            HTTP.get("category/adjustment")
            .then(response => {
              this.categories = response.data;
            })
            .catch(e => {
              this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
              });
            });
        },

        getMarkingByCode: _.debounce(
            function (query) {
                query = trim(query);

                if (query && query !== '' && this.isGroup == false) {
                    this.loadingGetMarking = true;
                    HTTP
                        .post('marking/getBySnapshot', {
                            markingHeaderId: query,
                            subbranchcode: this.searchSelectSubbranch || null
                        })
                        .then(response => {
                            this.loadingGetMarking = false;
                            let data = response.data;

                            const list = data.map(item => {
                                return {
                                    value: item.markingheaderid,
                                    label: item.markingheadercode
                                };
                            });

                            // buat nghandle SBR/SBRT (decimal)
                            if (this.markingIdSelected) {
                                this.paymentMarking = data[0].markingheadercode
                            }

                            this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        })
                        .catch(e => {

                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.optionMarkings = [];
                }
            }, 300
        ),
        getGroupMarkingByCode: _.debounce(
            function (query) {
                query = trim(query);
                if (query !== '' && this.isGroup) {
                    this.loadingGetMarking = true;
                    HTTP
                        .post('markingGroup/getByCode', {
                            groupName: query
                        })
                        .then(response => {
                            this.loadingGetMarking = false;
                            let data = response.data;

                            const list = data.map(item => {
                                return {
                                    value: item.id,
                                    label: item.code
                                };
                            });

                            this.optionGroupMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);

                            // handle to get total deposit
                            if (this.markingIdSelected) {
                                const dataMapping = response.data[0].detail;
                                const listMapping = dataMapping.map(item => {
                                    return {
                                        markingheadercode: item.markingheadercode,
                                        markingheaderid: item.markingheaderid
                                    };
                                });

                                this.listMarkingGroup = listMapping
                                this.depositRemaining = 0
                                this.getDepositGroup()
                                this.getDepositMutasiGroup()
                            }
                        })
                        .catch(e => {
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.optionGroupMarkings = [];
                }
            }, 300
        ),
        goToPaymentPendingList: function () {
            this.$router.push({ path: '/payment/paymentPending/list-data' })
        },
        setMarkingCode: function () {
            this.markingIdSelected = ''
        },
        groupClickHandle: function (indexTab) {
            console.info('groupClickHandle', this.markingIdSelected)
            this.selectGroup = this.receivableGroup[indexTab].markingheadercode
            let tempSum = 0
            this.receivableGroup[indexTab].invoiceDue.forEach(element => {
                tempSum += element.allocateAmount
            });
            this.totalAmountSelect = tempSum

            const markingHeaderId = this.receivableGroup[indexTab].invoiceDue[0].markingHeaderId

            HTTP
                .get('deposit/remaining/' + markingHeaderId)
                .then(response => {
                    this.groupDepositRemaining = response.data.remaining
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                });
        },
        getCOA: function () {
            HTTP.get("coa")
                .then(response => {
                    this.COAs = response.data;
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                });
        },
        getDepositGroup: function () {
            const parent = this;


            let markingHeaderIds = this.listMarkingGroup.map(value => value.markingheaderid);
            let groupDepositRemaining = 0;

            console.log(this.listMarkingGroup);


            let requests = markingHeaderIds.map(markingHeaderId => {

                return HTTP.get('deposit/remaining/' + markingHeaderId)
                    .then(response => {
                        groupDepositRemaining += response.data.remaining;
                    })
                    .catch(e => {
                        parent.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    });
            });

            Promise.all(requests)
                .then(() => {
                    parent.depositRemaining += groupDepositRemaining
                });
        },
        getDepositMutasiGroup: function () {
            const parent = this;

            let markingHeaderIds = this.listMarkingGroup.map(value => value.markingheaderid);
            let groupDepositRemaining = 0;

            let requests = markingHeaderIds.map(markingHeaderId => {
                return HTTP.get('deposit/mutasi/' + markingHeaderId)
                    .then(response => {
                        groupDepositRemaining += response.data.remaining;
                    })
                    .catch(e => {
                        parent.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    });
            });

            Promise.all(requests)
                .then(() => {
                    parent.depositMutasiRemaining += groupDepositRemaining
                });

        },
        handleSwitchChange: function (value) {
            this.description = '';
            this.amountReceived = 0;
            this.amountResidue = '';
            this.depositType = '';
            this.depositAmount = '';
            this.depositRemaining = 0;
            this.groupDepositRemaining = 0;
            this.totalUseDepositAmount = 0;
            this.totalUseDepositMutasi = 0;
            this.markingIdSelected = '';
            this.paymentMarking = '';
            this.optionMarkings = [];
            this.optionGroupMarkings = [];
            this.receivableGroup = [];
            this.selectGroup = '';
            this.totalAmountSelect = 0;
        },
    },
    filters: {
        currency: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0.00')
        }
    },
    watch: {
        amountReceived: function (newAmountReceived) {
            this.setResidueAmount(false)
        }
    },

    created() {
        this.usernameAccess = localStorage.getItem('user.username')
        this.getSubbranch();
        this.getCOA();
        this.getCategories();
    }
}

function groupBy(dataToGroupOn, fieldNameToGroupOn, fieldNameForGroupName, fieldNameForChildren) {
    var result = _.chain(dataToGroupOn)
        .groupBy(fieldNameToGroupOn)
        .toPairs()
        .map(function (currentItem) {
            return _.zipObject([fieldNameForGroupName, fieldNameForChildren], currentItem);
        })
        .value();
    return result;
}

</script>



// WEBPACK FOOTER //
// PaymentAdd.vue?5868d650